import './styles.less'

import ReactQuill from './QuillWrapper'

export default ReactQuill
